import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

interface CacheEntry {
  url: string;
  response: HttpResponse<any>;
  lastRead: number;
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache = new Map<string, CacheEntry>();
  private readonly MAX_CACHE_AGE = 10 * 60 * 1000; // 10 dəqiqə

  get(url: string): HttpResponse<any> | undefined {
    const entry = this.cache.get(url);
    if (!entry) return undefined;

    const isExpired = Date.now() - entry.lastRead > this.MAX_CACHE_AGE;
    if (isExpired) {
      this.cache.delete(url);
      return undefined;
    }

    return entry.response;
  }

  put(url: string, response: HttpResponse<any>): void {
    const entry: CacheEntry = { url, response, lastRead: Date.now() };
    this.cache.set(url, entry);
  }

  clear(): void {
    this.cache.clear();
  }
}
